import { Component, OnInit, Input, Output,
         EventEmitter, ViewChild } from '@angular/core';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'survey-form-modal',
  templateUrl: './survey-form-modal.component.html',
  styleUrls: ['./survey-form-modal.component.scss'],
  animations: [
    slide
  ]
})
export class SurveyFormModalComponent implements OnInit {
  @Input()  selectedSurvey: any;
  @Output() onHideFormModal = new EventEmitter<boolean>();

  survey = {
    name: "",
    surveyID: "",
    userLevels: []
  }

  membersAccess = false;
  ownersAccess  = false;
  vendorsAccess = false;


  constructor(private dbService: DBService) { }

  ngOnInit() {
    if (this.selectedSurvey) {
      this.survey = this.selectedSurvey;
      let acl = this.selectedSurvey.userLevels;

      this.membersAccess = (acl[1] == true);
      this.ownersAccess =  (acl[2] == true);
      this.vendorsAccess = (acl[0] == true);
    }
  }

  onHideModal() {
    this.onHideFormModal.emit(true);
  }

  submitForm() {

    this.survey.userLevels = [this.vendorsAccess,
                              this.membersAccess,
                              this.ownersAccess];

    if (this.selectedSurvey) {
      this.dbService.updateSurvey(this.selectedSurvey.$key,
                                  this.survey);
    } else {
      this.dbService.addSurvey(this.survey);
    }

    this.onHideModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/surveys/survey-form-modal/survey-form-modal.component.ts